export const reportMap = {
  "yht-performans-raporu": 59,
  "konvansiyonel-performans-raporu": 61,
  "tren-bazinda-kullanim-verisi": 6,
  "trenlerin-vagon-tipleri-bazinda-kullanim-verileri": 9,
  "tarife-ve-satis-kanali-bazinda-kullanim-verileri": 5,
  "tarife-bazinda-kullanim-verisi": 4,
  "tarife-tren-bilet-cikis-varis-ve-satis-kanali-bazinda-kullanim-verileri": 7,
  "seferlerin-tren-km-bazinda-vagon-tipleri-doluluk-oranlari": 3,
  "satis-kanali-bazinda-kullanim-verisi": 1,
  "bilet-cikis-varis-ve-tren-bazinda-kullanim-verisi": 2,
  "tren-bazinda-tren-km-doluluk-verisi": 8,
  "tren-bazinda-bagaj-ve-fark-biletleri-kullanim-verileri": 25,
  "satis-konduktor-raporu": 17,
  "tren-konduktor-raporu": 18,
  "indirim-ile-yapilan-islemleri-raporu": 16,
  "abonmanlik-ile-gerceklesen-bilet-islem-raporu": 19,
  "indirim-paket-satis-raporu": 27,
  "abonmanlik-paket-satis-raporu": 28,
  "bilet-tipi-bazinda-satis-raporu": 51,
  "indirim-iptal-islemleri-raporu": 36,
  "abonmanlik-paket-iptal-islemleri-raporu": 37,
  "permi-kullanim-raporu": 21,
  "permi-satis-raporu": 22,
  "detayli-reddiyat-raporu": 24,
  "tehir-tazminat-raporu": 48,
  "kurumdan-kaynakli-iade-islemleri-raporu": 30,
  "tehirli-tren-bilet-degisikligi-iadesi-sorgulama-raporu": 33,
  "yolcu-bilet-rezervasyonlama-sorgulama-raporu": 13,
  "tarife-bazli-islemler-raporu": 14,
  "acik-bilet-islemleri-raporu": 15,
  "sefer-anlik-islem-raporu": 20,
  "pos-satislari-raporu": 26,
  "aktarmali-trenler-raporu": 31,
  "bilet-kontrol-raporu": 34,
  "sefer-tarihine-gore-yolcu-bilgileri-raporu": 12,
  "turistik-satis-raporu": 39,
  "tum-islem-raporu": 41,
  "banka-islem-sorgulama-raporu": 43,
  "musteri-istatistiki-bilgi-sorgulama-raporu": 49,
  "amir-onay-tarihce": 53,
  "kullanici-bazli-mrz-islem-raporu": 55,
  "birim-bazli-mrz-islem-raporu": 56,
  "personel-performans-raporu": 54,
  "kullanici-giris-cikis-raporu": 57,
  "tren-türü-bazlı-satış-verileri-raporu": 52,
  "islem-smsleri-raporu": 62,
  "sms-sorgulama": 63,
};

export const reverseReportMap = Object.entries(reportMap).reduce((acc, [key, value]) => {
  acc[value] = key; // Her bir değeri anahtar olarak, anahtarı değer olarak ekle
  return acc;
}, {});
